/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { withTranslation } from 'language/i18n';
import maskAmount from 'utils/maskAmount';
import { Button } from 'components/common';
import { getCurrency } from 'models/payment';

const PayDepositSide = ({
  t, offers, machine, minimumIncrement,
}) => {
  const [currency, setCurrency] = useState(0);

  useEffect(() => {
    currencyEuroFromTl();
  }, []);

  const currencyEuroFromTl = async () => {
    const approxValue = await getCurrency(offers?.length > 0 ? offers[0].offer : machine.auctionStartPrice);
    setCurrency(approxValue);
  };

  return (
    <div className="col-15 col-sm">
      <div className="im-box im-box--white im-box--border-radius im-box--mh-100">
        <div className="text-center mt-5 mb-5">
          <div className="fs-35 fw-900 mb-2">{maskAmount(offers?.length > 0 ? offers[0].offer : machine.auctionStartPrice)}</div>
          <div className="fs-15">{offers?.length > 0 ? t('currentHighOffer') : 'Başlangıç Fiyatı'}</div>
          <div className="fs-13 text-gray3 mt-1">
            {`(${t('approx')} ${maskAmount(currency, 'TRY')})`}
          </div>
        </div>
        <div className="row align-items-center justify-content-center mb-5">
          <div className="col-auto text-center">
            <div className="fs-15 fw-900 text-gray3 mb-2">{maskAmount(minimumIncrement)}</div>
            <div className="fs-12 text-gray3">{t('priceIncrease')}</div>
          </div>
          <div className="col-auto text-center">
            <div className="fs-15 fw-900 text-gray3 mb-2">{offers?.length ? offers.length : 0}</div>
            <div className="fs-12 text-gray3">{t('numberOfOffers')}</div>
          </div>
        </div>
        <div className="text-center mb-5" style={{ marginTop: 120 }}>
          <span className="fs-15">
            Teklif verebilmek için
            {' '}
            <span className="fs-15 fw-900 mb-2">teminat bedelini ödeyiniz.</span>
          </span>
        </div>
        <div className="col-15">
          <Link href="/payment/deposit">
            <Button
              withoutFormItem
              htmlType="submit"
              className="im-button im-button--primary im-button--size-60 im-button--center im-button--fluid fw-900"
              label="Teminat Bedeli Öde"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

PayDepositSide.propTypes = {
  t: PropTypes.func,
  offers: PropTypes.array,
  machine: PropTypes.object,
  minimumIncrement: PropTypes.number,
};

export default withTranslation('common')(PayDepositSide);
